import type { PaginationParams, SourceResource } from "@prequel/import-react";
import { useImportContext } from "@prequel/import-react";

import { useAllPages } from "@/api/pagination";

export type { SourceResource } from "@prequel/import-react";

const keys = { all: ["import", "sources"] as const };

export function useAllSources(providerId?: string, options?: { enabled?: boolean }) {
  const { sources } = useImportContext();

  return useAllPages<SourceResource>(
    [...keys.all, providerId ?? ""],
    (params: PaginationParams) => sources.list({ ...params, provider_id: providerId }),
    options,
  );
}
